import { FULL_ACCESS_ACTION_NAMES } from 'widget/ui-selectors/video-access';

import { DEFAULT_TRANSLATIONS as CHANNEL_TRANSLATIONS } from 'widget/components/overlay-texts/channel/play-button-text';

import commonTranslations from 'shared/translations/overlay-common-translations';


export default function getTranslationData(availableVideoType, fullAccessAction) {
  if (availableVideoType) {
    return {
      props: CHANNEL_TRANSLATIONS[availableVideoType],
    };
  } else if (fullAccessAction === FULL_ACCESS_ACTION_NAMES.SIGN_IN) {
    return {
      props: commonTranslations.startWatching,
    };
  }

  return {
    props: commonTranslations.startWatching,
  };
}



// WEBPACK FOOTER //
// ./src/widget/views/desktop/compact/components/player-overlay/ui-selectors/channel-overlay/play/translation-data.js